import * as Sentry from '@sentry/browser'

import { sentryOptions } from './constants'

if ('FinvizSentrySettings' in window && !('sentryDisabled' in window)) {
  Sentry.init({
    ...sentryOptions,
    beforeSend(event: Sentry.Event) {
      if ('sentryDisabled' in window) {
        return null
      }
      return event
    },
  })

  if (FinvizSentrySettings.id > 0) {
    Sentry.setUser({ id: String(FinvizSentrySettings.id) })
  }
}

window['Sentry'] = {
  captureException: Sentry.captureException,
  captureMessage: Sentry.captureMessage,
  withScope: Sentry.withScope,
}
